import { useState } from "react";
import { BASE_URL } from "../utils/config";
import Sidebar from "../components/sidebar";

import {
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TablePagination,
    TableRow,
    Dialog,
    DialogTitle,
    DialogActions,
    DialogContent,
    DialogContentText,
    Button, Box, Switch, FormControlLabel,

} from "@mui/material";

import Loading from "../components/loading";


const StockSRTable = ({ RecordData, updateRecordData, handleUpdateChild,  }) => {
    const columns = [

        { id: "S.No", label: "S.No", minWidth: 40 },
        { id: "symbol", label: "Stock Symbol", minWidth: 110 },
        { id: "support", label: "Support", minWidth: 100 },
        { id: "resistance", label: "Resistance", minWidth: 100 },
        { id: "UserName", label: "Changed By", minWidth: 120 },
        { id: "modified_at", label: "Changed At", minWidth: 90 },
        { id: "Action", label: "Action", minWidth: 70 },
    ];

    const [, setEditRecord] = useState({});
    const [loading, ] = useState(false);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(25);
    const [startIndex, setStartIndex] = useState(0);
    const [endIndex, setEndIndex] = useState(25);

    const [filteredRecord, ] = useState([]);

    const [successDialog, setSuccessDialog] = useState(false);
    const [errorDialog, setErrorDialog] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [successMessage, setSuccessMessage] = useState("");

    const [confirmOpen, setConfirmOpen] = useState(false);
    const [pendingRow, setPendingRow] = useState(null);
    const [telegramToggle, setTelegramToggle] = useState(true);
    const [isSending, setIsSending] = useState(false);


    // const onlyNumbersOrEmpty = /^\d*$/;
    const onlyNumbersOrEmpty = /^(\d+(\.\d*)?)?$/;


    //  handle page change for pagination
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
        let startindex = newPage * rowsPerPage;
        console.log("startindex", startindex);
        let endindex = Math.min(startindex + rowsPerPage, RecordData.length);
        console.log("endindex", endindex);
        setStartIndex(startindex);
        setEndIndex(endindex);
    };

    // handle row change in page
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setEndIndex(+event.target.value);
        setStartIndex(0);
        setPage(0);
    };

    //  hanlde api call to update the record

    const handleUpdate = async () => {
  if (!pendingRow) return;

  setIsSending(true);

  const details = JSON.parse(localStorage.getItem("loginData"));

  if (!details || !details.token) {
    setErrorMessage("You are not logged in.");
    setErrorDialog(true);
    setIsSending(false);
    return;
  }

  const body = JSON.stringify({
  support:
    pendingRow.support === "" || pendingRow.support === null
      ? null
      : parseFloat(pendingRow.support),

  resistance:
    pendingRow.resistance === "" || pendingRow.resistance === null
      ? null
      : parseFloat(pendingRow.resistance),

  modifiedBy: details.user_id,
  sendTelegram: hasSRValue && telegramToggle
});

  try {
    const response = await fetch(
      `${BASE_URL}/updateStockgtandsr/SR/${pendingRow.id}`,
      {
        method: "PUT",
        body,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${details.token}`,
        },
      }
    );

    const res = await response.json();

    if (res.status !== 200) {
      throw new Error(res.message || "Update failed");
    }

    setSuccessMessage("Stock SR Updated Successfully.");
    setSuccessDialog(true);
    handleUpdateChild();

    setTimeout(() => {
      setIsSending(false);
      setConfirmOpen(false);
      setSuccessDialog(false);
      setPendingRow(null);
    }, 2000);

  } catch (err) {
    setIsSending(false);
    setErrorMessage(err.message);
    setErrorDialog(true);
  }
};
    
    const UpdateRecordSR = (row) => {
  setPendingRow(row);

  const hasSR =
    (row.support !== "" && row.support !== null) ||
    (row.resistance !== "" && row.resistance !== null);

  setTelegramToggle(hasSR); // default ON only if SR exists
  setConfirmOpen(true);
};


    const handlechangeSR = (id, changeType, newValue) => {
console.log("id", id, "changeType", changeType, "newValue", newValue)
        let testresult = onlyNumbersOrEmpty.test(newValue)
        console.log("testres", testresult)
        if (!testresult) {
            setErrorMessage(`Enter valid ${changeType} Numerical value`);
            setErrorDialog(true);
            setTimeout(() => {
                setErrorDialog(false)
                setErrorMessage('')
            }, 2000);
            return;
        }
        const record = RecordData.find(item => item.id === id);
        if (!record) return;

//        const currentValue = record.support;

//        if (currentValue === newValue) {
//            // No change → skip API call
//            return;
//        } else {

            setEditRecord(record)
            updateRecordData(id, changeType, newValue)
//        }
    }

    
const hasSRValue =
  pendingRow &&
  (
    (pendingRow.support !== "" && pendingRow.support !== null) ||
    (pendingRow.resistance !== "" && pendingRow.resistance !== null)
  );

    const renderSupport = (row) => {


        
        return (
            <div >
                <input
                    name="support"

                    value={row.support}
                    onChange={(e) => handlechangeSR(row.id, 'support', e.target.value)}
                />


            </div>
        )
    }

    const renderResistance = (row) => {

        return (
            <div >
                <input
                    name="resistance"

                    value={row.resistance}
                    onChange={(e) => handlechangeSR(row.id, 'resistance', e.target.value)}
                />


            </div>
        )
    }

    const formatDateTime = (row) => {
        // console.log("row.datetome",row.modified_at)
        const utcDate = new Date(row.modified_at);
        // console.log("isbadet",utcDate) 

        const date = utcDate.toLocaleDateString("en-IN", {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
        });

        const time = utcDate.toLocaleTimeString("en-IN", {
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: true
        });

        return (
            <div>
                <p style={{ marginBottom: '0px' }}>Date: {date}</p>
                <p style={{ marginBottom: '0px' }}>Time: {time}</p>
            </div>
        )
    }

    return (
        <>
            <Sidebar />
            {loading ? (
                <div
                    style={{
                        position: "fixed",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        zIndex: 2,
                    }}
                >
                    <Loading />
                </div>
            ) : (
                <div >

                    <div className="container-fluid">
                        <div className="table">
                            <Paper sx={{ width: "100%", overflow: "hidden" }}>
                                <TableContainer sx={{ maxHeight: 370 }}>
                                    <Table
                                        style={{ margin: 0 }}
                                        stickyHeader
                                        aria-label="sticky table"
                                    >
                                        <TableHead>
                                            <TableRow>
                                                {columns.map((column, index) => (
                                                    <TableCell
                                                        key={column.id}
                                                        align={column.align}

                                                        style={{
                                                            textAlign: "center",
                                                            minWidth: column.minWidth,
                                                            backgroundColor: "#23499E",
                                                            color: "white",
                                                        }}
                                                    >
                                                        {column.label}
                                                    </TableCell>
                                                ))}
                                            </TableRow>
                                        </TableHead>
                                        {RecordData.length > 0 ? (
                                            <TableBody>
                                                {RecordData
                                                    .slice(startIndex, endIndex)
                                                    .map((row, index) => {
                                                        return (
                                                            <TableRow
                                                                hover
                                                                role="checkbox"
                                                                tabIndex={-1}
                                                                key={row.code}
                                                            >
                                                                
                                                                {columns.map((column) => {
                                                                    const value = row[column.id];
                                                                    return (
                                                                        <TableCell
                                                                            style={{
                                                                                position: "sticky",
                                                                                backgroundColor: "#fff",


                                                                            }}
                                                                            class="table-cell-screenerTab"
                                                                            key={column.id}
                                                                            align={column.align}
                                                                        >                                                                            
                                                                            {column.id === "S.No" ? (
                                                                                index + 1
                                                                            ) : column.id === "Action" ? (
                                                                                <div>
                                                                                    <button
                                                                                        onClick={() =>
                                                                                            UpdateRecordSR(row)
                                                                                        }>
                                                                                        Update
                                                                                    </button>


                                                                                </div>
                                                                            ) : column.id === "support" ? (
                                                                                renderSupport(row)

                                                                            ) : column.id === "resistance" ? (
                                                                                renderResistance(row)

                                                                            ) : column.id === "modified_at" ? (
                                                                                    formatDateTime(row)
                                                                                ) : ( value                                                                                   
                                                                                    )}
                                                                        </TableCell>
                                                                    );
                                                                })}
                                                            </TableRow>
                                                        );
                                                    })}
                                            </TableBody>
                                        ) : null}
                                    </Table>
                                </TableContainer>
                                <TablePagination
                                    rowsPerPageOptions={[25, 50, 75, 100]}
                                    component="div"
                                    count={filteredRecord.length}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    onPageChange={handleChangePage}
                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                />
                            </Paper>
                        </div>
                    </div>



                    {/*Error Message Dialog */}
                    <Dialog
                        open={errorDialog}
                        onClose={() => { setErrorDialog(false) }}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                    >
                        <DialogTitle id="alert-dialog-title">
                            <h4 style={{ color: "red" }}>Failure</h4>
                        </DialogTitle>
                        <DialogContent>
                            <DialogContentText id="alert-dialog-description">


                                {errorMessage}


                            </DialogContentText>
                        </DialogContent>

                    </Dialog>

                    {/*Success Message Dialog */}
                    <Dialog
                        open={successDialog}
                        onClose={() => { setSuccessDialog(false) }}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                    >
                        <DialogTitle id="alert-dialog-title">
                            <h4 style={{ color: "green" }}>Success</h4>

                        </DialogTitle>
                        <DialogContent>
                            <DialogContentText id="alert-dialog-description">


                                <span style={{ color: "black" }}>
                                    {successMessage}
                                </span>


                            </DialogContentText>
                        </DialogContent>

                    </Dialog>


                {/*confirmation  dialog */}
                <Dialog open={confirmOpen} onClose={() => setConfirmOpen(false)}>
                <DialogTitle style={{ color: "#2380DE" }}>
                    Confirm Update
                </DialogTitle>

                <DialogContent>
                    <DialogContentText sx={{ mb: 2 }}>
                    Are you sure you want to update SR levels?
                    </DialogContentText>

                    {/* SR PREVIEW */}
                    <Box display="flex" justifyContent="center" gap={3} mb={2} flexWrap="wrap">
                    {pendingRow?.support && (
                        <Box sx={{ border: "1px dashed #c4c4c4", borderRadius: "10px", p: 2 }}>
                        <div style={{ fontSize: "12px", color: "#666" }}>Support</div>
                        <div style={{ fontSize: "18px", fontWeight: "bold", color: "#c62828" }}>
                            {pendingRow.support}
                        </div>
                        </Box>
                    )}

                    {pendingRow?.resistance && (
                        <Box sx={{ border: "1px dashed #c4c4c4", borderRadius: "10px", p: 2 }}>
                        <div style={{ fontSize: "12px", color: "#666" }}>Resistance</div>
                        <div style={{ fontSize: "18px", fontWeight: "bold", color: "#2e7d32" }}>
                            {pendingRow.resistance}
                        </div>
                        </Box>
                    )}
                    </Box>

                    {/* TELEGRAM TOGGLE */}
                    {hasSRValue && (
                    <Box display="flex" justifyContent="center">
                        <FormControlLabel
                        control={
                            <Switch
                            checked={telegramToggle}
                            onChange={(e) => setTelegramToggle(e.target.checked)}
                            />
                        }
                        label="Send on Telegram"
                        />
                    </Box>
                    )}
                </DialogContent>

                <DialogActions sx={{ justifyContent: "center", gap: 2 }}>
                    <Button
                    variant="outlined"
                    color="error"
                    onClick={() => setConfirmOpen(false)}
                    disabled={isSending}
                    >
                    Cancel
                    </Button>

                    <Button
                    variant="outlined"
                    color="success"
                    onClick={handleUpdate}
                    disabled={isSending}
                    >
                    {isSending
                        ? "Sending..."
                        : hasSRValue && telegramToggle
                        ? "Send & Update"
                        : "Update"}
                    </Button>
                </DialogActions>
                </Dialog>                 



                </div>
            )}
        </>
    );
};

export default StockSRTable;

